import React from 'react'

const street_exit = ({street_exit}) => {
  return (
    <div className="card p-2">
      <div>
        <h5>
          Monthly Street Exits
        </h5>
        {street_exit.monthly}
      </div>
      <div>
        <h5>
          YTD Street Exits
        </h5>
        {street_exit.ytd}
      </div>
    </div>
  )
}

export default street_exit